import { ClusterModel } from './domain/cluster.model'

export const LAYER_SIZE = {
  LITTLE: 'small',
  MEDIUM: 'medium',
  LARGE: 'big'
} as const

export type LayerSizeKeys = keyof typeof LAYER_SIZE
export type LayerSizeType = (typeof LAYER_SIZE)[LayerSizeKeys]

export type ClustersPayloadType = {
  [LAYER_SIZE.LITTLE]: ClusterModel[]
  [LAYER_SIZE.MEDIUM]: ClusterModel[]
  [LAYER_SIZE.LARGE]: ClusterModel[]
}

export type ClusterParams = {
  zoomLevel: number
  minLat: number
  minLon: number
  maxLat: number
  maxLon: number
}

export type ClustersDto = ClusterParams & {
  targetSize: LayerSizeType
  abortSignal?: AbortSignal
}
